export default {
    formId: 'editarAreaForm', //'checkoutForm',
    formField: {
      e_name: {
        name: 'e_name',
        label: 'Nombre area*',
        requiredErrorMsg: 'El nombre area es requerido.'
      },
      e_description: {
        name: 'e_description',
        label: 'Descripcion*',
        requiredErrorMsg: 'La descripcion es requerida.'
      },
      e_sucursal: {
        name: 'e_sucursal',
        label: 'Sucursal*',
        requiredErrorMsg: 'La sucursal es requerida.'
      },
    }
};
  